export const SET_SITE_SUMMARY_IS_LOADING = '@dashboardRevamp/basicDashboard/SET_SITE_SUMMARY_IS_LOADING';
export const SET_ASSIGNEE_SUMMARY_IS_LOADING = '@dashboardRevamp/basicDashboard/SET_ASSIGNEE_SUMMARY_IS_LOADING';
export const SET_DEPARTMENT_SUMMARY_IS_LOADING = '@dashboardRevamp/basicDashboard/SET_DEPARTMENT_SUMMARY_IS_LOADING';
